module.exports = __webpack_public_path__ + "static/media/footer-social-lin.fd0d5546.png";